module.exports = __webpack_public_path__ + "bffcda03723b288e2b6b9d96d3ebc212.jpg";